import { create } from 'zustand';

export const useApplicationRequestInformationStore = create((set) => ({
  // Data state
  items: [],
  selectedItem: null,

  // Pagination
  paginationData: {
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    itemsPerPage: 10,
    hasNextPage: false,
    hasPreviousPage: false
  },

  // Column filters & unique values
  columnFilters: {},
  uniqueValues: {},

  // Status
  loading: false,
  error: null,

  // UI state
  isFormOpen: false,
  isEditMode: false,
  isDeleteDialogOpen: false,
  itemToDelete: null,
  itemToDelete: null,

  // === Pure State Setters ===
  setItems: (items) => set({ items }),
  setSelectedItem: (selectedItem) => set({ selectedItem }),
  setPaginationData: (paginationData) => set({ paginationData }),
  setColumnFilters: (columnFilters) => set({ columnFilters }),
  setUniqueValues: (uniqueValues) => set({ uniqueValues }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
  clearError: () => set({ error: null }),

  // === UI Actions ===

  // Form actions
  openCreateForm: () => set({
    isFormOpen: true,
    isEditMode: false,
    selectedItem: null,
    error: null
  }),

  openEditForm: (item) => set({
    isFormOpen: true,
    isEditMode: true,
    selectedItem: item,
    error: null
  }),

  closeForm: () => set({
    isFormOpen: false,
    isEditMode: false,
    selectedItem: null,
    error: null
  }),

  // Delete dialog actions
  openDeleteDialog: (item) => set({
    isDeleteDialogOpen: true,
    itemToDelete: item
  }),

  closeDeleteDialog: () => set({
    isDeleteDialogOpen: false,
    itemToDelete: null
  }),

}));

export default useApplicationRequestInformationStore;
